import { ButtonProps } from '../../atoms/Button';
import { InlineNotificationProps } from '../../atoms/InlineNotification';
import { TextProps } from '../../atoms/Text';
import { AddressProps } from '../../molecules/Address';
import { InputFieldProps } from '../../molecules/InputField';
import { PriceListItemProps } from '../../molecules/PriceListItem';
import { TextGroupProps } from '../../molecules/TextGroup';


type StudentAppFeeBlockInternalProps = {
  stepperText?: TextProps;
  textGroup?: TextGroupProps;
  priceListItem?: PriceListItemProps;
  cardInfoField?: InputFieldProps;
  address?: AddressProps;
  button?: ButtonProps;
  inlineNotification?: InlineNotificationProps;
};

type StudentAppFeeBlockPropsValues = {
  '': StudentAppFeeBlockInternalProps;
};

const propValues: StudentAppFeeBlockPropsValues = {
  '': {
    stepperText: {
      style: 'Semibold',
      align: 'Left',
      colour: 'Default',
      type: 'Body2',
    },
    textGroup: {
    },
    priceListItem: {
      type: 'Total',
    },
    cardInfoField: {
      state: 'Default',
    },
    address: {
    },
    button: {
      style: 'Contained',
      size: 'Large',
      type: 'TextIcon',
      colour: 'PrimaryAction',
    },
    inlineNotification: {
      type: 'Error',
    },
  },
};

const getProps = (type: string): StudentAppFeeBlockInternalProps => {
  const values: StudentAppFeeBlockInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
